"use strict";
/** Схемы форм аутентификации. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPasswordSchema = exports.loginSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.loginSchema = zod_1.z.object({
    email: common_1.emailSchema,
    /**
     * При входе длина пароля не проверяется: требования к новому паролю не должны
     * подсказывать, каким может быть чужой. Ошибка входа всегда одна и та же.
     */
    password: zod_1.z.string().min(1, 'Введите пароль').max(200),
    /** Продлевать ли сессию на полный срок. */
    rememberMe: zod_1.z.boolean().default(true),
});
exports.setPasswordSchema = zod_1.z
    .object({
    token: zod_1.z.string().min(20, 'Некорректная ссылка'),
    password: common_1.passwordSchema,
    passwordConfirmation: zod_1.z.string(),
})
    .refine((value) => value.password === value.passwordConfirmation, {
    message: 'Пароли не совпадают',
    path: ['passwordConfirmation'],
});
//# sourceMappingURL=auth.js.map